import Text from 'components/elements/Text'
import Button from 'components/elements/Button'

function FileGroupList({ files }) {
  /* 2개 나오는 경우 있어 gap 필요 */
  return (
    <div className="file-group mt24">
      {files.map((file) => (
        <Button className="file-btn" key={file.id}>
          <span className="icon-download" />
          <Text text={`${file.name} (${file.size})`} />
        </Button>
      ))}
    </div>
  )
}

export default FileGroupList
